import { LeaveReviewComponentContactDiv, LeaveReviewComponentHeroMainDiv, LeaveReviewComponentMainDiv } from "../../styles/reviewcomponentsstyles/leavereviewcomponentstyles"
import IndexFaqComponent from "../indexcomponents/indexfaqcomponent"
import IndexReviewsComponent from "../indexcomponents/indexsreviewscomponent"
import Footer from "../reusable/footer/footer"
import ButtonComponent from "../reusable/header/assetes/buttoncomponents/butttoncomponent"
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan"
import HeaderComponent from "../reusable/header/header"
import {  ReactComponent as ArrowIcon} from "./assets/arrow-left-solid-full.svg";

const LeaveReviewComponent = ()=>{

    return(<LeaveReviewComponentMainDiv>
         <div className="header-holder">
                <HeaderComponent />
            </div>
            <LeaveReviewComponentHeroMainDiv>
                <div>
                    <div className="leavereview-container">
                        <div className="leavereview-header-container ">
                            <div className="leavereview-header-wrapper">
                                <div>
                                    <HeaderSpan text="Review " />
                                </div>
                                <div className="leavereview-header-text-wrapper">
                                    <h1> Leave a review </h1>
                                </div>

                            </div>
                            <div>
                                <div className="leavereview-header-text-wrapper ">
                                    <p>
                                        Fusion AI helps you tackle data bottlenecks, streamline analysis, and make smarter decisions with ease.


                                    </p>
                                </div>
                            </div>

                        </div>
                        <div className="leavereview-form-container">

                            <LeaveReviewComponentContactDiv>
                                <div className="leavereview-info-header-text-container">
                                    <div className="leavereview-info-header-text-wrapper">
                                        <p><a href="tel: 050-333-333-334" target="_blank " rel="noopener " >  (050) 333-333-334 </a> </p>
                                    </div>
                                    <div className="leavereview-info-header-text-wrapper">

                                        <h3>
                                            <a href="mailto:hello@bugziai.com" target="_blank " rel="noopener">
                                                hello@bugziai.com

                                            </a>
                                        </h3>

                                    </div>

                                </div>

                                <div className="leavereview-address-info-container">
                                    <div className="leavereview-address-info-wrapper">

                                        {
                                            data.map((item, index) => (
                                                <div className="leavereview-address-info-item-container">
                                                    <div className="leavereview-address-info-text-wrapper">
                                                        <p> Address</p>
                                                    </div>
                                                    <div className="leavereview-address-info-text-wrapper leavereview-address-info-address-text-wrapper">
                                                        <p> 123 Creative Lane, Washington, D.C., 20001

                                                        </p>
                                                    </div>
                                                </div>

                                            ))
                                        }


                                    </div>
                                    <div>
                                        <div className="leavereview-address-link-container">
                                            {
                                                data.map((item, index) => (
                                                    <a className="leavereview-link-wrapper" href="/">

                                                        <div className="leavereview-icon-wrapper">
                                                            <ArrowIcon />

                                                        </div>
                                                        <div className="leavereview-link-text-container">
                                                            <div className="leavereview-link-text-wrapper ">
                                                                <p> Instagram</p>
                                                            </div>
                                                            <div className="leavereview-link-text-wrapper ">

                                                                <p> Instagram</p>
                                                            </div>

                                                        </div>

                                                    </a>

                                                ))
                                            }



                                        </div>

                                    </div>

                                </div>

                            </LeaveReviewComponentContactDiv>
                            <div className="leavereview-form-left">
                                <form className="leavereview-form-wrapper">
                                    <div className="leavereview-form-input-container">

                                        <input className="leavereview-form-input-wrapper" placeholder="name *" required ></input>
                                    </div>
                                    <div className="leavereview-form-input-container">

                                        <input className="leavereview-form-input-wrapper" placeholder="e-mail *" required ></input>
                                    </div>
                                    <div className="leavereview-form-input-container">

                                        <input className="leavereview-form-input-wrapper" placeholder="phone "  ></input>
                                    </div>
                                    <div className="leavereview-form-input-container">

                                        <textarea className="leavereview-form-input-wrapper leavereview-form-text-area-wrapper " placeholder="message " maxLength={4} minLength={1} />
                                    </div>

                                </form>
                                <div className="leavereview-form-bottom">
                                    <div>
                                        <ButtonComponent title="submit" />
                                    </div>
                                    <div className="leavereview-form-bottom-text-wrapper">
                                        <p className="">
                                            By submitting this form you agree to our friendly
                                            <a href="/privacy"> privacy policy </a>
                                        </p>
                                    </div>

                                </div>

                            </div>



                        </div>
                    </div>
                </div>
            </LeaveReviewComponentHeroMainDiv>
            <IndexReviewsComponent/>
            <IndexFaqComponent/>
            <div>
                <Footer/>
            </div>

    </LeaveReviewComponentMainDiv>)
}
const data = [""," "]

export default LeaveReviewComponent